import { updatePetOwner } from "../../api/petOwnerService";

export const useUpdatePetOwner = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedPetOwner = await updatePetOwner(id, data);
        if (successCallback) successCallback(updatedPetOwner);
        return updatedPetOwner;
    } catch (error) {
        console.error("Failed to update pet owner:", error);
        throw error;
    }
  };

  return { update };
};